import React from 'react';
import { Row, Col, Form, Input } from 'antd';
import { FormInstance } from 'antd/lib/form';
import RuleListModal from './RuleListModal';
import { useModalState } from 'hooks/useModalState';
import CheckButtonList from 'components/CheckButtonListe';
import FormInput from 'components/FormInput';
import { setValueByNamePath } from 'utils/utils2';

type ApplicationRuleProps = {
  module?: string;
  form: FormInstance;
  name: (string | number)[] | string;
  xs?: number;
  width?: number;
  comcode?: string;
  noStyle?: boolean;
  disabled?: boolean;
};

const ApplicationRule = (props: ApplicationRuleProps) => {
  const { module, name, form, xs, width, noStyle, disabled } = props;
  const { close, open, visible } = useModalState();
  const setCheckedApplicationRule = (value: string) => {
    if (typeof name === 'string') {
      props.form.setFieldsValue({ [name]: value });
    } else {
      setValueByNamePath(form, name, value);
    }
  };
  return !xs ? (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div>
        <Form.Item name={name} noStyle={noStyle}>
          <Input disabled={disabled} style={{ width: width?width-50 :200 }} />
        </Form.Item>
      </div>
      <div>
        <CheckButtonList
          noStyle={noStyle}
          onClick={(e: { stopPropagation: () => void }) => {
            e.stopPropagation();
            open();
          }}
          disabled={disabled}
        />
        <RuleListModal
          module={module}
          valueRule={props.form.getFieldValue(name)}
          setApplicationRule={setCheckedApplicationRule}
          onCancel={close}
          visible={visible}
        />
      </div>
    </div>
  ) : (
    <FormInput col xs={xs} noStyle={noStyle} xl={xs} lg={xs} name={name}>
      <Row gutter={1}>
        <Col xs={18} xl={18} lg={18}>
          <Form.Item name={name} noStyle={noStyle}>
            <Input disabled={disabled} />
          </Form.Item>
        </Col>
        <Col xs={4} xl={4} lg={4}>
          <CheckButtonList
            noStyle={noStyle}
            onClick={(e: { stopPropagation: () => void }) => {
              e.stopPropagation();
              open();
            }}
            disabled={disabled}
          />
          <RuleListModal
            module={module}
            valueRule={props.form.getFieldValue(name)}
            setApplicationRule={setCheckedApplicationRule}
            onCancel={close}
            visible={visible}
          />
        </Col>
      </Row>
    </FormInput>
  );
};
export default ApplicationRule;
